<template>
  <tabs :tabs="tabs" :entityType="entityType" :entityId="entityId" />
</template>

<script>
import Tabs from '@/components/tabs/Tabs';
import { TableName } from '@/enums/tableName.enum';

// @vuese
// Zakładki grupy treningowej
// @group Team
export default {
  components: { Tabs },
  data() {
    return {
      tabs: [
        { title: 'tabs.team.details', route: { name: 'team', params: this.$route.params }, permissions: ['TEAM.GET'] },
        {
          title: 'tabs.team.calendar',
          route: { name: 'teamCalendar', params: { ...this.$route.params, view: 'week' } },
          permissions: ['TEAM.EVENTS']
        },

        {
          title: 'tabs.team.players',
          route: { name: 'teamPlayers', params: this.$route.params },
          permissions: ['USER.LIST']
        },
        {
          title: 'tabs.team.coaches',
          route: { name: 'teamCoaches', params: this.$route.params },
          permissions: ['USER.LIST']
        },
        {
          title: 'tabs.team.schedules',
          route: { name: 'teamSchedules', params: this.$route.params },
          permissions: ['CLUB.EVENTS']
        },
        {
          title: 'tabs.team.fee',
          route: { name: 'teamFees', params: this.$route.params },
          permissions: ['FEE.LIST']
        },
        {
          title: 'tabs.team.presences',
          route: { name: 'teamPresences', params: this.$route.params },
          permissions: ['PRESENCE.LIST']
        },
        {
          title: 'tabs.team.feePresence',
          route: { name: 'feePresences', params: this.$route.params },
          permissions: ['PRESENCE.LIST']
        },
        {
          title: 'tabs.team.exam',
          children: [
            {
              title: 'tabs.team.examManage',
              route: { name: 'teamExamsManage', params: this.$route.params },
              permissions: ['EXAM.LIST']
            },
            {
              title: 'tabs.team.examConduct',
              route: { name: 'teamExamsConduct', params: this.$route.params },
              permissions: ['EXAM.LIST']
            }
          ]
        }
      ],
      entityType: TableName.Team,
      entityId: this.$route.params.teamId.toString()
    };
  }
};
</script>
